import { formatLongPrice } from '@benzinga/calendars';
import React from 'react';

import { SidebarRow } from '../../../app/(site)/government-trades/_components/SidebarRow';

interface TradeRowProps {
  company_name?: string;
  logo?: string;
  percent?: number;
  positions_active?: number;
  ticker?: string;
  trade_amount?: string;
  transaction_type?: string;
  total_trades?: number;
  ttm_return?: number;
}

export const TradeRow: React.FC<TradeRowProps> = ({
  company_name,
  logo,
  percent,
  positions_active,
  ticker,
  trade_amount,
  transaction_type,
}) => {
  const volume = trade_amount?.split(' - ')[0]?.replace('$', '')?.replaceAll(',', '') ?? '';
  const direction = transaction_type === 'S' ? 'sell' : 'buy';
  const isPercent = percent !== undefined;

  const common = {
    uppercaseTitle: true,
    tinted: !isPercent,
    href: ticker ? `/government-trades/securities/${ticker}` : undefined,
    linkTitleOnly: true,
    media: logo ? <img alt={`${company_name} logo`} src={logo} /> : undefined,
    title: ticker,
    subtitle: company_name,
  } as const;

  if (isPercent) {
    return (
      <SidebarRow
        {...common}
        value={`${(percent * 100).toFixed(2)}%`}
        valueTone={percent > 0 ? 'pos' : 'neg'}
        pill={transaction_type ? { label: direction, tone: direction } : undefined}
      />
    );
  }

  if (positions_active) {
    return <SidebarRow {...common} value={positions_active} subValue="positions active" />;
  }

  if (trade_amount) {
    return (
      <SidebarRow
        {...common}
        value={`${transaction_type === 'S' ? '-' : ''}${formatLongPrice(volume).replace('.00', '')}`}
        valueTone={direction === 'buy' ? 'pos' : 'neg'}
        pill={{ label: direction, tone: direction }}
      />
    );
  }

  return <SidebarRow {...common} />;
};
